import type { SVGProps } from 'react';
const SvgCreatorMax = ({ width = 50, height = 50, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    width={width}
    height={height}
    fill="none"
    {...props}
  >
    <rect width={50} height={50} fill="url(#creator-max_svg__a)" rx={8} />
    <rect width={50} height={50} fill="url(#creator-max_svg__b)" rx={8} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M25.41 43.917c-3.75 0-5.492-.548-8.522-2.738-1.916 2.464-7.984 4.39-8.249 1.095 0-2.473-.547-4.562-1.168-6.844-.739-2.81-1.578-5.94-1.578-10.475 0-10.831 8.887-18.98 19.417-18.98 10.54 0 18.798 8.55 18.798 19.08.035 10.368-8.33 18.806-18.697 18.862m.156-28.58c-5.128-.264-9.125 3.285-10.01 8.851-.73 4.609.566 10.22 1.67 10.512.529.128 1.861-.949 2.692-1.779a9.5 9.5 0 0 0 4.635 1.652 9.764 9.764 0 0 0 10.21-9.098 9.764 9.764 0 0 0-9.197-10.129z"
      clipRule="evenodd"
    />
    <defs>
      <radialGradient
        id="creator-max_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(51.356 22.242 -12.217)scale(60.6759 25)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00F" />
        <stop offset={1} stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="creator-max_svg__a"
        x1={5.892}
        x2={50}
        y1={38.027}
        y2={25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4CF" />
        <stop offset={0.662} stopColor="#53E" />
        <stop offset={1} stopColor="#93D" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgCreatorMax;
